const React = require("react");
const T = React.PropTypes;

require("./SurveyNav.less");

const SurveyType = require("~/types/Survey.js").PropType;
const QuestionValidationStatus = require("~/types/QuestionValidationStatus.js");
const SectionIsPositivelyValid = QuestionValidationStatus.SectionIsPositivelyValid;
const sectionDispatchers = require("~/events/section/sectionDispatchers.js");
const AuditTypes = require("~/config.js").AuditTypes;
const Navigator = require("~/navigator.js");
const Config = require("~/config.js"); 

const StatusMarker = require("./StatusMarker/StatusMarker.jsx");

const auditCompletionDispatchers = require("~/events/auditCompletion/auditCompletionDispatchers.js"); 

const SectionStatus = {
    Incomplete: "STATUS.INCOMPLETE",
    Complete: "STATUS.COMPLETE",
    Any: "STATUS.ANY"
};

const Survey = React.createClass({
    propTypes: {
        Survey: SurveyType.isRequired
    },
    getInitialState() {
        return {
            SelectedSectionStatus: SectionStatus.Any
        };
    },
    render() {
        const title = this.GetTitle();
        const list = this.GetList();
        const bottom = this.GetBottom();

        if (this.props.Survey.IsLoading) {
            return (<div className="cs-SurveyNav">
                Loading sections...
            </div>);
        }

        return (<div className="cs-SurveyNav">
            {title}
            {list}
            {bottom}
        </div>);
    },
    GetTitle() {
        const auditType = AuditTypes[this.props.Survey.Type];

        const typeName = (auditType ? auditType.FriendlyName : "") || "Type unknown";

        const title = (<div>
            <dl className="dl-horizontal cs-SurveyNav__title__list">
                <dt className="cs-SurveyNav__title__term">Store</dt>
                <dd className="cs-SurveyNav__title__def">{this.props.Survey.FacilityNumber}</dd>
                <dt className="cs-SurveyNav__title__term">Type</dt>
                <dd className="cs-SurveyNav__title__def">{typeName}</dd>
                <dt className="cs-SurveyNav__title__term">Period</dt>
                <dd className="cs-SurveyNav__title__def">{this.props.Survey.AuditPeriod}</dd>
            </dl>
        </div>);

        return title;
    },
    GetList() {
        if (!this.props.Survey.Pages) return null;

        const filter = this.GetFilter();
        const page = this.FindCurrentPage();

        const filterer = this.GetFilterer();

        const filteredSections = page.Sections
            .filter(filterer)
            .map(this.MakeSectionItem);

        const sections =
            filteredSections.length
            ? filteredSections
            : (<li className="cs-SurveyNav__section-item--empty">None found.</li>);

        return (<div className="cs-SurveyNav__sections">
            {filter}
            <div className="style2 cs-SurveyNav__sections__box">
                <ol className="cs-SurveyNav__list">
                    {sections}
                </ol>
            </div>
        </div>);
    },
    GetFilterer() {
        switch(this.state.SelectedSectionStatus)
        {
            case SectionStatus.Complete:
                return (s) => SectionIsPositivelyValid(s);
            case SectionStatus.Incomplete:
                return (s) => !SectionIsPositivelyValid(s);
            default:
                return () => true;
        }
    },
    MakeSectionItem(section, i) {
        const className =
            section.GUID === this.props.Survey.CurrentSectionGUID
            ? "cs-SurveyNav__section-item--selected"
            : "cs-SurveyNav__section-item";
        
        const isValid = SectionIsPositivelyValid(section);

        const clicked = this.GetSectionClickHandler(section);

        return (<li key={i} className={className} onClick={clicked}>
            <StatusMarker IsValid={isValid} />
            &nbsp;
            <span className="cs-SurveyNav__section-item-text">
                {section.TitleHTML}
            </span>
        </li>);
    },
    GetBottom() {
        if (!this.props.Survey.Pages) return null;

        const sections = this.FindCurrentPage().Sections;
        const completeSectionCount = this.GetCompleteCount();
        const sectionCount = sections.length;
        const isComplete = completeSectionCount === sectionCount;

        const statusText = isComplete
            ? "100% complete!"
            : `${completeSectionCount}/${sectionCount} sections complete`;

        const buttonClassName = isComplete
            ? "btn btn-primary cs-SurveyNav__submit"
            : "btn btn-primary cs-SurveyNav__submit";

        {/*const walkThruURL = `#walk-thru/${this.props.Survey.Type}/${this.props.Survey.FacilityNumber}/${this.props.Survey.GUID}`; */}

        return (<footer className="cs-SurveyNav__footer">
            {/*<a href={walkThruURL} className="cs-SurveyNav__walk-thru">
                View Walk Thru
            </a>*/}
            <strong className="cs-SurveyNav__status">
                {statusText}
            </strong>
            {isComplete && (<button onClick={this.ReviewAndSubmit} className={buttonClassName} disabled={!isComplete}>
                Review and submit
            </button>)}
        </footer>);
    },
    ReviewAndSubmit() {
        const pageIDPath = [
            this.props.Survey.Type,
            this.props.Survey.FacilityNumber,
            this.props.Survey.GUID,
            this.props.Survey.CurrentPageGUID];
        const currentSection = this.props.Survey.Pages
            .find(
                p => p.GUID === this.props.Survey.CurrentPageGUID)
            .Sections
            .find(
                s => s.GUID === this.props.Survey.CurrentSectionGUID);
        sectionDispatchers.Save(pageIDPath, currentSection, function () {
            Navigator.InCurrentPage.GoToSection(Config.ConfirmationPage); 
        });
    }, 
    GetCompleteCount() {
        const page = this.FindCurrentPage();

        const validSections = page.Sections.filter(SectionIsPositivelyValid);

        return validSections.length;
    },
    GetFilter() {
        return (<div className="input-group cs-SurveyNav__filter">
            <span className="input-group-addon cs-SurveyNav__filter__label">
                Filter
            </span>
            <select className="form-control cs-SurveyNav__filter__select"
                    onChange={this.FilterChange}>
                <option value={SectionStatus.Any}>
                    All
                </option>
                <option value={SectionStatus.Incomplete}>
                    Incomplete
                </option>
                <option value={SectionStatus.Complete}>
                    Complete
                </option>
            </select>
        </div>);
    },
    FilterChange(e) {
        this.setState({
            SelectedSectionStatus: e.target.value
        });
    },
    FindCurrentPage() {
        return this.props.Survey.Pages
            .find(p => p.GUID === this.props.Survey.CurrentPageGUID);
    },
    GetSectionClickHandler(section) {
        return () => {
            const pageIDPath = [
                this.props.Survey.Type,
                this.props.Survey.FacilityNumber,
                this.props.Survey.GUID,
                this.props.Survey.CurrentPageGUID];

            const currentSection = this.props.Survey.Pages
                .find(
                    p => p.GUID === this.props.Survey.CurrentPageGUID)
                .Sections
                .find(
                    s => s.GUID === this.props.Survey.CurrentSectionGUID);

            sectionDispatchers.LeaveSection(
                pageIDPath,
                currentSection,
                this.props.Survey.CurrentQuestionSnapshot,
                section.GUID);
        };
    }
});

module.exports = Survey;


// WEBPACK FOOTER //
// ./src/components/SurveyNav/SurveyNav.jsx